import { EditableMediaTypes } from "../enums/editables";

export default function isMediaType(type: string) {
    return EditableMediaTypes.includes(type as (typeof EditableMediaTypes)[number]);
}
